/**
 * Helper function to get full image URL
 * Converts relative paths to full URLs with API base
 */
export const getImageUrl = (imageUrl: string | null | undefined): string => {
  if (!imageUrl) return '';
  
  // Nếu đã là URL đầy đủ (http/https) hoặc data URI, return luôn
  if (imageUrl.startsWith('http') || imageUrl.startsWith('https') || imageUrl.startsWith('data:')) {
    return imageUrl;
  }
  
  // Nếu là relative path, thêm API URL
  // Backend serve static files tại /uploads
  return `${process.env.REACT_APP_API_URL}${imageUrl}`;
};

/**
 * Get audio URL - similar logic to image URL
 */
export const getAudioUrl = (audioUrl: string | null | undefined): string => {
  if (!audioUrl) return '';
  
  if (audioUrl.startsWith('http') || audioUrl.startsWith('https') || audioUrl.startsWith('data:')) {
    return audioUrl;
  }
  
  return `${process.env.REACT_APP_API_URL}${audioUrl}`;
};
